import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NewChatV2 = _resolveComponent("NewChatV2")
  const _component_NewChatV1 = _resolveComponent("NewChatV1")

  return ($options.chat_2)
    ? (_openBlock(), _createBlock(_component_NewChatV2, { key: 0 }))
    : (_openBlock(), _createBlock(_component_NewChatV1, { key: 1 }))
}